<template>
  <div v-if="showModal">
    <!-- <Dialog
      :transition-names="[]"
      v-model="showModal"
      :title="ttle"
      @on-cancel="cancel"
      width="800"
      footer-hide
    >-->
    <b-modal
      v-model="showModal"
      @hide="cancel()"
      hide-footer
      hide-header
      centered
      body-class="pd-0"
      size="lg"
    >
      <div class="modal-header pd-y-20 pd-x-20 pd-sm-x-30">
        <a
          role="button"
          aria-label="Close"
          class="close pos-absolute t-15 r-15"
          @click="cancel()"
        >
          <span aria-hidden="true">×</span>
        </a>
        <div class="media align-items-center">
          <feather type="folder"></feather>
          <div class="media-body mg-sm-l-20">
            <h4 class="tx-18 tx-sm-20 mg-b-2">
              {{ ttle }} {{ selectedTypeId == 0 ? "үүсгэх" : "засах" }}
            </h4>
            <p class="tx-13 tx-color-03 mg-b-0">
              Тохирох утгуудыг бөглөөд хадгалах дарна уу
            </p>
          </div>
        </div>
      </div>

      <div class="ivu-row-flex d-flex">
        <div class="ivu-col ivu-col-span-6 wd-40p">
          <!-- <ButtonGroup>
            <Button @click="addSub(0)" type="success">
              <i class="ivu-icon ivu-icon-md-add"></i> Шинэ
            </Button>
            <Button v-if="selectedTypeId != 0" type="warning" @click="editSub(selectedTypeId)">
              <i class="ivu-icon ivu-icon-md-settings"></i> Засах
            </Button>
          </ButtonGroup>-->
          <div class="pd-10 bg-white">
            <button
              class="btn btn-outline-light btn-xs btn-block"
              @click="addSub(0)"
            >
              <i class="icon ion-md-add tx-14 mg-r-5 pd-t-5"></i> Шинэ
              <span class="tx-lower">{{ ttle }}</span> үүсгэх
            </button>
          </div>

          <nav class="nav nav-sidebar tx-13 m-b-md m-t-xs">
            <a
              class="nav-link"
              role="button"
              v-for="(t, i) in types"
              @click="editSub(t.id)"
              :key="i"
              :title="t.field1"
            >
              <!-- <tag-icon v-if="ttle=='Хавчуурга'" :style="{'color': t.s2 }"></tag-icon>
              <folder-icon v-else :style="{'color': t.s2 }"></folder-icon>-->
              <feather type="edit"></feather>
              <span class="nav-title">{{ t.s1 }}</span>
            </a>
          </nav>
        </div>
        <div class="ivu-col ivu-col-span-18 wd-60p bd-l">
          <!-- <Divider /> -->

          <Form
            v-show="editMode"
            v-model="locTypeModel"
            label-position="top"
            label-width="100%"
            class="pd-10"
          >
            <FormItem :label="ttle" class="m-b-sm">
              <Input v-model="locTypeModel.name" placeholder="___" />
            </FormItem>
            <FormItem label="Өнгө" class="m-b-sm">
              <Select v-model="locTypeModel.value" clearable>
                <Option value="red">
                  <!-- <tag-icon v-if="ttle=='Хавчуурга'" size="1x" style="color: red"></tag-icon> -->
                  <!-- <folder-icon v-else size="1x" style="color: red"></folder-icon> -->
                  Улаан
                </Option>
                <Option value="green">
                  <!-- <tag-icon v-if="ttle=='Хавчуурга'" size="1x" style="color: green"></tag-icon>
                  <folder-icon v-else size="1x" style="color: green"></folder-icon>-->
                  Ногоон
                </Option>
                <Option value="orange">
                  <!-- <tag-icon v-if="ttle=='Хавчуурга'" size="1x" style="color: orange"></tag-icon>
                  <folder-icon v-else size="1x" style="color: orange"></folder-icon>-->
                  Шар
                </Option>
                <Option value="blue">
                  <!-- <tag-icon v-if="ttle=='Хавчуурга'" size="1x" style="color: blue"></tag-icon>
                  <folder-icon v-else size="1x" style="color: blue"></folder-icon>-->
                  Хөх
                </Option>
              </Select>
              <Input v-model="locTypeModel.value" placeholder="#FF0000" />
            </FormItem>
            <FormItem v-if="flag != null" label="Тайлбар" class="m-b-sm">
              <Input
                v-model="locTypeModel.field1"
                placeholder="Тайлбар"
                disabled
              />
            </FormItem>
            <FormItem v-else label="Тайлбар" class="m-b-sm">
              <Input v-model="locTypeModel.field1" placeholder="Тайлбар" />
            </FormItem>
            <FormItem label="Дараалал" class="m-b-sm">
              <InputNumber
                v-model="locTypeModel.ord"
                placeholder="___"
              ></InputNumber>
            </FormItem>
            <!-- <Button size="large" @click="saveLocType" type="primary" icon="ios-checkmark">Хадгалах</Button> -->
          </Form>
        </div>
      </div>
      <div class="modal-footer pd-x-20 pd-y-15">
        <button type="button" class="btn btn-white" @click="cancel()">
          Болих
        </button>
        <button v-show="editMode" class="btn btn-primary" @click="saveLocType">
          {{ selectedTypeId == 0 ? "Үүсгэх" : "Засах" }}
        </button>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { request } from "@/api/all";
import "element-ui/lib/theme-chalk/index.css";
import {
  Form,
  Input,
  FormItem,
  //Divider,
  InputNumber,
  Select,
  Option
  //Button
} from "element-ui";

export default {
  components: {
    Form,
    FormItem,
    Input,
    //Divider,
    InputNumber,
    Select,
    Option
    //Button
  },
  name: "addTagModal",
  props: {
    shw: {
      type: Boolean,
      default: () => false
    },
    lkey: {
      type: String,
      default: () => ""
    },
    flag: {
      type: Number,
      default: () => null
    }
  },
  data() {
    return {
      ttle: "Хавчуурга",
      showModal: false,
      types: [],
      selectedTypeId: 0,
      locTypeModel: {},
      editMode: false
    };
  },
  mounted() {},
  watch: {
    shw: function(newVal) {
      this.showModal = newVal == true;
      if (newVal == true) {
        this.init(true);
      }
    }
  },
  methods: {
    init(force) {
      if (this.lkey.includes("sysProjectFolder")) {
        this.ttle = "Бүлэг";
      } else if (this.lkey.includes("sysProjectTag")) {
        this.ttle = "Хавчуурга";
      } else {
        this.ttle = "Төрөл";
      }

      request({
        api: { method: "get", url: "Type/GetData" },
        params: { key: this.lkey, getParentType: false },
        store: this.$store
      }).then(res => {
        if (res != false) {
          if (force) this.addSub(0);
          if (this.flag != null) {
            this.types = res.data.types.filter(x => x.field1 == this.flag);
          } else {
            this.types = res.data.types;
          }
        }
      });
    },
    addSub(id) {
      if (id == 0) this.selectedTypeId = 0;
      this.editMode = true;
      this.locTypeDetail(0, id == 0 ? 0 : id);
    },
    editSub(id) {
      this.selectedTypeId = id;
      this.editMode = true;
      this.locTypeDetail(id, 0);
    },
    locTypeDetail(id, pid) {
      request({
        api: { method: "get", url: "Type/GetInheritedDetail" },
        params: { id: id, parentId: pid, key: this.lkey },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.locTypeModel = res.data;
          if (id == 0 && this.flag == 600) {
            this.locTypeModel.field1 = "600";
          }
        }
      });
    },
    saveLocType() {
      request({
        api: { method: "post", url: "Type/PostType" },
        data: { model: this.locTypeModel },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.editMode = false;
          this.postedId = res.data.typeId;
          this.selectedTypeId = res.data.typeId;
          this.init();
          this.$emit("on-load");
        }
      });
      // postType({ model: this.locTypeModel }).then(res => {
      //   if (res != false) {
      //     this.editMode = false;
      //     this.postedId = res.data.typeId;
      //     this.selectedTypeId = res.data.typeId;
      //     this.init();
      //     this.$emit("on-load");
      //   }
      // });
    },
    cancel() {
      Object.assign(this.$data, this.$options.data());
      this.$emit("on-close");
    }
  }
};
</script>
